module.exports = __webpack_public_path__ + "dd1c5396c3899c6876dd1a2a6aa59524.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/call_your_elites-420.jpg
// module id = 204
// module chunks = 0